import React from "react";
import { DialogContent, Typography } from "@mui/material";
import { Done } from "@mui/icons-material";
import { t } from "i18next";

export const SupplierContactDataConfirmationSuccess = () => {
    return <DialogContent className={"contact-validation-feedback-popup"}>
        <div className={"contact-validation-popup__icon"}>
            <Done color={"success"} />
        </div>
        <Typography>
            {t("components.supplierValidationPopup.success")}
        </Typography>
    </DialogContent>;
};
